export default __webpack_public_path__ + "static/media/exterior5.a197fbec.jpeg";